// Bar grows 40px -> 44px when the panel opens (per Figma spec).
export const SEARCH_BAR_HEIGHT_CLOSED = 40;
export const SEARCH_BAR_HEIGHT_OPEN = 44;
export const FILTER_ROW_HEIGHT = 40; // category chips + Search options dropdown
export const HELP_FOOTER_TOTAL_HEIGHT = 60; // HELP_FOOTER_HEIGHT (48) + StyledFooterWrapper's margin-top
export const DIVIDER_HEIGHT = 32; // StyledDivider's height + margin
export const RESULTS_AREA_HEIGHT = 304; // recent searches / results / skeleton + wrapper padding

export enum ResultsCategory {
	Assets = 'assets',
	Collections = 'collections',
	Guidelines = 'guidelines',
}

export type SelectedResultsCategory = ResultsCategory | null;

type DropdownHeightParams = {
	hasFilterRow: boolean;
	hasResultsContent: boolean;
	hasFooter: boolean;
};

// Drives StyledOuterDiv's animated height, so the dropdown grows/shrinks smoothly as content changes.
export function getDynamicDropdownHeight({
	hasFilterRow,
	hasResultsContent,
	hasFooter,
}: DropdownHeightParams): number {
	let height = 0;

	if (hasFilterRow) {
		height += FILTER_ROW_HEIGHT;
	}

	if (hasResultsContent) {
		height += DIVIDER_HEIGHT + RESULTS_AREA_HEIGHT;
	}

	if (hasFooter) {
		height += HELP_FOOTER_TOTAL_HEIGHT;
	}

	return height;
}
